import React,{useEffect}from'react';import{useNavigate}from'react-router-dom';export default function SetPassword(){const navigate=useNavigate();useEffect(()=>{navigate('/reset-password',{replace:true})},[navigate]);return null}
